import React from 'react';
import { WARRANTY_YEARS } from '../../config/warranty';

// Six-item value-prop ticker below the hero. The track contains
// two duplicate groups so CSS can animate a seamless horizontal
// scroll. Icons are inlined here because each is unique to this
// component — Sun/Rain/Wind/Shield from icons.js are sized for
// CompareClaims, while these use a custom 22px stroke for the
// marquee aesthetic.
export default function MarqueeStrip() {
  return (
    <section className="asg-marquee" aria-label="Product benefits">
      <div className="asg-marquee-track">
        {[0, 1].map((dup) => (
          <div className="asg-marquee-group" key={dup} aria-hidden={dup === 1}>
            <span className="asg-marquee-item">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <circle cx="12" cy="12" r="4" />
                <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>
              </svg>
              Sun Protection
            </span>
            <span className="asg-marquee-item">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M7 17a5 5 0 1 1 1-9.9A6 6 0 0 1 20 11a4 4 0 0 1-1 7.9" />
                <path d="M8 19v2M12 19v3M16 19v2" />
              </svg>
              Rain Protection
            </span>
            <span className="asg-marquee-item">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M3 8h11a3 3 0 1 0-3-3" />
                <path d="M3 14h15a3 3 0 1 1-3 3" />
                <path d="M3 11h9" />
              </svg>
              Wind Tested - AW01
            </span>
            <span className="asg-marquee-item">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M12 2 4 5v6c0 5 3.5 9 8 11 4.5-2 8-6 8-11V5l-8-3z" />
                <path d="m9 12 2 2 4-4" />
              </svg>
              {WARRANTY_YEARS} Year Warranty
            </span>
            <span className="asg-marquee-item">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <rect x="1" y="6" width="15" height="12" rx="1.5" />
                <path d="M16 10h3l3 3v5h-6z" />
                <circle cx="6" cy="19" r="2" />
                <circle cx="18" cy="19" r="2" />
              </svg>
              Free delivery to most of Melbourne
            </span>
            <span className="asg-marquee-item">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <rect x="7" y="2" width="10" height="20" rx="2" />
                <path d="M11 18h2" />
              </svg>
              Phone Compatibility
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
